import { requireStates, ConnectComponent2 } from "util";
import View from "./company.view";
import Presenter from "./company.presenter";

const initialStates = [
  {
    name: "app.registration.company",
    url: "/empresas",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 200,
        name: "Empresas",
        state: "app.registration.company"
      },
      authorization: context =>
        context.user.permissions.includes("manage_companies")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/company/index.js